module.exports = __webpack_public_path__ + "Roboto-Bold.39b2c3031be6b4ea96e2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Bold.woff2
// module id = 300
// module chunks = 2